module.exports = [{
      plugin: require('/tmp/3603219a/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
